import styled, { keyframes } from 'styled-components'

const flagAnimation = keyframes`
  0% {
    transform: translateX(-100vw); /* not visible - left */
  }

  26.7% { /* 800ms of 3000ms */
    transform: translateX(0); /* transition to middle */
  }

  30% { /* stops for ~100ms of 30000ms */
    transform: translateX(0); /* visible- center  */
  }

  43.3% { /* 400ms of 30000ms*/
    transform: translateX(100vw); /* transition to right */
  }

  100% {
    transform: translateX(100vw); /* not visible - right */
  }
`

const EntityTransactionViewContainer = styled.div`
  min-height: 100vh;
  min-width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  overflow-x: hidden;
`

const FlagContainer = styled.section`
  width: 100%;
  animation-delay: 1ms;
  animation: ${flagAnimation} 3000ms ease-in-out;
  padding-bottom: 24px;
`

const EntityTransactionViewContentContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 12px;
`

const TitleTextContaier = styled.p`
  width: 100%;
  color: var(--typography500);
  font-family: 'Sora', sans-serif;
  font-size: var(--Type-Size-Display-Small, 32px);
  font-style: normal;
  font-weight: 500;
  line-height: var(--Type-LineHeight-Display-Small, 40px);
  letter-spacing: var(--Type-LetterSpacing-Display-Small, -0.02px);
`

const DetailsTextContaier = styled.p`
  width: 100%;
  color: var(--typography400);
  text-align: center;
  font-family: 'Inter', sans-serif;
  font-size: var(--Type-Size-Body-Large, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--Type-LineHeight-Body-Large, 24px); /* 150% */
  letter-spacing: var(--Type-LetterSpacing-Body-Large, 0);
`

const FootnoteTextContaier = styled.p`
  width: 100%;
  color: var(--typography400);
  text-align: center;
  font-family: 'Inter', sans-serif;
  font-size: var(--Type-Size-Caption-Medium, 11px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--Type-LineHeight-Caption-Medium, 14px);
  letter-spacing: var(--Type-LetterSpacing-Caption-Medium, 0);
`

const EntityTransactionViewFootnoteContainer = styled.section`
  width: 100%;
  position: absolute;
  padding: 20px;
  bottom: 0px;
`

export {
  EntityTransactionViewContainer,
  FlagContainer,
  TitleTextContaier,
  DetailsTextContaier,
  FootnoteTextContaier,
  EntityTransactionViewContentContainer,
  EntityTransactionViewFootnoteContainer,
}
